import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ContactUsClient, Inquiry, InquiryType, WebinarClient, WebinarRoom } from '../Services/WOWApi.Service';
import { CustomServiceService } from '../Services/custom-service.service';
import { Subscription } from 'rxjs';
import { CommonService } from '../Services/common.service';
import { CommonServices } from '../Common/CommonServices';
import { Console } from 'console';

@Component({
    selector: 'app-contact-us',
    templateUrl: './contact-us.component.html',
    styleUrls: ['./contact-us.component.css'],
    standalone: false
})
export class ContactUsComponent implements OnInit {
  form: UntypedFormGroup;  
  showSpinner:boolean = false;
  webinarRooms: WebinarRoom[];
  inquiryTypes:InquiryType[];
  inquiry:Inquiry;
  isMobileView = false;
  subscription: Subscription;
  constructor(private formBuilder: UntypedFormBuilder,private webinarClient: WebinarClient,
    private contactUsClient:ContactUsClient , private customServices:CustomServiceService,
    private commonService: CommonService, private commonServices: CommonServices ) { }
    

  ngOnInit(): void {
    this.subscription = this.commonService.isMobileView.subscribe(res => this.isMobileView = res);
    this.GetForm();
    this.GetWebinars();
    this.GetInquiryType();
  }

  GetForm() {
    this.form = this.formBuilder.group({
      webinarRoom: ['', Validators.required],
      inquiryType: ['', Validators.required],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      emailId: ['', [Validators.required,Validators.email]],
      phoneNumber: ['',[Validators.required,Validators.pattern("^[0-9]*$"), Validators.minLength(8), Validators.maxLength(15)]],
      freeText: ['', [Validators.required, Validators.minLength(50)]]
    });
  }
   
  GetWebinars() {
    this.webinarClient.getWebinarRooms(false).subscribe(data => {
      this.webinarRooms = data;
    }, error => { });
  }
  GetInquiryType()
  {
    this.contactUsClient.getInquiryTypes().subscribe(data => {
      this.inquiryTypes = data;
    }, error => { });
  }

  Save() {
    console.log("Form Valid: ", this.form);
    this.form.markAllAsTouched();
    if (!this.form.valid) {
      this.commonServices.showMessage('error', 'please fill all the required fields to proceed', 3);
      return
    }
    const firstName = this.form.controls.firstName.value;
    const lastName = this.form.controls.lastName.value
    const hasLettersFirstName = /[a-zA-Z]/.test(firstName);
    const hasLettersLastName = /[a-zA-Z]/.test(lastName);
    if (!hasLettersFirstName) {
      this.commonServices.showMessage('error', 'Charactor is mandatory in First Name', 5);
      return false;
    }
    if (!hasLettersLastName) {
      this.commonServices.showMessage('error', 'Charactor is mandatory in Last Name', 5);
      return false;
    }
    this.showSpinner = true;
    this.GetFormData();
    this.contactUsClient.createInquiry(this.inquiry).subscribe(data  => {
      this.showSpinner = false;
      this.form.reset();
      alert("Inquiry Submitted Sucessfully");
    });

  }
  GetFormData() {
    this.inquiry = new  Inquiry();
    this.inquiry.email = this.form.controls["emailId"].value;
    this.inquiry.firstName = this.form.controls["firstName"].value;
    this.inquiry.lastName = this.form.controls["lastName"].value;
    this.inquiry.phoneNumber = this.form.controls["phoneNumber"].value;
    this.inquiry.webinarRoomId = this.form.controls["webinarRoom"].value;
    this.inquiry.inquiryTypeId = this.form.controls["inquiryType"].value;
    this.inquiry.openText = this.form.controls["freeText"].value;
  }

  onlyNumbers(event: KeyboardEvent) {
    const input = String.fromCharCode(event.charCode);
    const pattern = /^[0-9]+$/;
    if (!pattern.test(input)) {
      event.preventDefault();
      this.commonServices.showMessage('error', 'Numbers only', 2);
    }
  }
}
